function email(email) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) return null;
  else if (!email.length) return null;
  return "Plesae enter a valid email";
}

function name(name) {
  if (!name.length) return "Please enter name";
  else if (name.length < 2) return "Plesae enter a valid name";
  return null;
}

export const phone = (mobile) => {
  if (!mobile.length && mobile.length !== 10)
    return "Mobile number should be of 10 digits";
  return null;
};

export const validate = {
  email,
  name,
  phone,
};
